import type { ThemeConfig } from '@/types/theme'

/** Cinzas claros conhecidos que falham WCAG AA sobre fundo branco. */
const LIGHT_TEXT_FAIL_ON_WHITE = new Set([
  '#a1a1aa',
  '#9ca3af',
  '#d4d4d8',
  '#d1d5db',
  '#e4e4e7',
])

const SAFE_PRIMARY = '#09090b'
const SAFE_SECONDARY = '#18181b'
const SAFE_BODY = '#3f3f46'
const SAFE_MUTED = '#52525b'

function isTooLightForWhite(color: string | undefined): boolean {
  if (!color) return false
  const raw = color.trim().toLowerCase()
  if (LIGHT_TEXT_FAIL_ON_WHITE.has(raw)) return true
  const hex = raw.startsWith('#') ? raw.slice(1) : ''
  const full = hex.length === 3 ? hex.split('').map((part) => part + part).join('') : hex
  if (full.length !== 6) return false
  const value = Number.parseInt(full, 16)
  if (Number.isNaN(value)) return false
  const r = (value >> 16) & 255
  const g = (value >> 8) & 255
  const b = value & 255
  return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 > 0.45
}

function readable(color: string | undefined, fallback: string): string {
  return !color || isTooLightForWhite(color) ? fallback : color
}

/** No tema claro, troca texto claro demais (salvo de um tema escuro) por cinza escuro. */
export function withLightAccessibleText(theme: ThemeConfig): ThemeConfig {
  if (theme.mode !== 'light') return theme

  return {
    ...theme,
    textPrimary: readable(theme.textPrimary, SAFE_PRIMARY),
    textSecondary: readable(theme.textSecondary, SAFE_SECONDARY),
    textHeader: readable(theme.textHeader, SAFE_PRIMARY),
    textSidebar: readable(theme.textSidebar, SAFE_SECONDARY),
    textMuted: readable(theme.textMuted, SAFE_MUTED),
    fontColorH1: readable(theme.fontColorH1, SAFE_PRIMARY),
    fontColorH2: readable(theme.fontColorH2, SAFE_SECONDARY),
    fontColorH3: readable(theme.fontColorH3, SAFE_BODY),
    fontColorH4: readable(theme.fontColorH4, SAFE_BODY),
    fontColorH5: readable(theme.fontColorH5, SAFE_MUTED),
    fontColorH6: readable(theme.fontColorH6, SAFE_MUTED),
    fontColorBody: readable(theme.fontColorBody, SAFE_BODY),
    fontColorMuted: readable(theme.fontColorMuted, SAFE_MUTED),
    fontColorLabel: readable(theme.fontColorLabel, SAFE_MUTED),
  }
}
